<template>
    <div v-if="visible" class="card info-card">
        <span class="title-and-close-button">
            <p class="title" v-html="info.title"></p>
            <button type="button" class="btn  close-button" @click="closeButton"  aria-label="Close">
            <i class="fas fa-times"></i>
        </button>
        </span>
        <p class="body" v-html="info.body"></p>
    </div>
</template>

<script>


    export default {
        name: "InfoCard",
        components: {},
        props: {
            info: Object
        },
        mixins: [],
        methods: {
            closeButton() {
                this.visible = false;
              localStorage.setItem(this.info.id, "seen");
            }
        },
        data() {
            return {
                visible: true
            }
        },
        created() {
          if (localStorage.getItem(this.info.id) === "seen") {
            this.visible = false;
          }
        }
    }
</script>

<style lang="scss" scoped>
    .info-card {
        display: flex;
        flex-direction: column;
        padding: 21px;
        width: 100%;

        .title-and-close-button {
            display: flex;
            justify-content: space-between;
        }

        .title{
            font-size: 1rem;
            font-weight: bold;
            margin-bottom: 0.3rem;
        }

        .body {
            font-size: 0.9rem;
            margin-bottom: 0.3rem;
        }

        .close-button {
            background-color: $primary-blue;
            border-radius: 15px;
            padding: 0rem 0.55rem;
            max-height: 1.8rem;
            font-size: 0.8rem;
            color: $font-light;
            position: relative;
            top: -10px;
        }

        @media screen and (max-width: $large) {
            width: auto;
            margin: 0 1rem;

        }
    }

</style>